import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'DialogConfirmDelete',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class DialogConfirmDelete extends Vue {
  isVisible!: boolean;
  title!: string;
  message!: string;
  isDialogVisible = false;

  get dialogTitle() {
    return this.title;
  }

  get dialogMessage() {
    return this.message;
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
